<div
    class="main-loader"
    [class.dynamic-mode]="(loaderService.content | async)?.isDynamic"
    [class.default-mode]="!(loaderService.content | async)?.isDynamic"
>
    <div class="loader-content">
        <ng-container *ngIf="loaderService.content | async as data">
            <ng-container *ngIf="data?.isDynamic; else defaultLoader">
                <div class="top-content">
                    <h2 class="top-title">{{ data.topTitle }}</h2>
                    <p class="top-description">{{ data.topDescription }}</p>
                </div>

                <div class="lottie-icon-box" *ngIf="lottie">
                    <ng-lottie class="lottie-img" [options]="lottie.brandLoader"></ng-lottie>
                </div>

                <div class="bottom-content">
                    <p class="bottom-title">{{ data.bottomTitle }}</p>
                    <p class="bottom-description">{{ data.bottomDescription }}</p>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #defaultLoader>
            <div class="lottie-icon-box" *ngIf="lottie">
                <ng-lottie class="lottie-img" [options]="lottie.brandLoader"></ng-lottie>
            </div>
        </ng-template>
    </div>
</div>
